"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_BREAKPOINT = exports.URL_REGEX = exports.HTTPS_URL_PREFIX = exports.WWW_URL_PREFIX = exports.trimTrailingSlash = exports.compileKeysOfObjectArray = exports.distanceDisplayString = exports.round = exports.getUnitAbbreviation = exports.timeValueToTimePicker = exports.timePickerToTimeValue = exports.dateValueToDatePicker = exports.datePickerToDateValue = exports.startOfDay = exports.isNotUndefined = exports.moveNullToBeginning = exports.useExtensions = exports.dataURItoBlob = void 0;
const set_1 = __importDefault(require("lodash/set"));
const union_1 = __importDefault(require("lodash/union"));
function dataURItoBlob(dataURI) {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    const currentDateTime = new Date().getTime();
    const blob = new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
    // name required in file object to get url from image. so added
    set_1.default(blob, 'name', `captured_image_${currentDateTime}`);
    return blob;
}
exports.dataURItoBlob = dataURItoBlob;
const useExtensions = (extensions, prefix) => {
    return extensions.map(x => `.${x}`).join(prefix);
};
exports.useExtensions = useExtensions;
const moveNullToBeginning = (currList) => {
    // moves null field to the beginning of the array so it always shows at the top of filter list
    const sortedList = [];
    currList.forEach((field) => (field ? sortedList.push(field) : sortedList.unshift(field)));
    return sortedList;
};
exports.moveNullToBeginning = moveNullToBeginning;
const isNotUndefined = (x) => x !== undefined;
exports.isNotUndefined = isNotUndefined;
const startOfDay = (date) => {
    const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    // take the date in the UTC format, 0 out the time and return a new Date
    const regex = /(\d\d\d\d-\d\d-\d\d).*Z/;
    return new Date(midnight.toJSON().replace(regex, '$1T00:00:00.000Z'));
};
exports.startOfDay = startOfDay;
const datePickerToDateValue = (date) => {
    return exports.startOfDay(date).getTime();
};
exports.datePickerToDateValue = datePickerToDateValue;
const dateValueToDatePicker = (dateNum) => {
    const offset = new Date(dateNum).getTimezoneOffset() * 60 * 1000;
    return new Date(dateNum + offset);
};
exports.dateValueToDatePicker = dateValueToDatePicker;
const timePickerToTimeValue = (time) => {
    return time.getTime() - exports.startOfDay(time).getTime();
};
exports.timePickerToTimeValue = timePickerToTimeValue;
const timeValueToTimePicker = (timeNum) => {
    const currentDate = new Date();
    const midnight = exports.startOfDay(currentDate).getTime();
    return new Date(midnight + timeNum);
};
exports.timeValueToTimePicker = timeValueToTimePicker;
const getUnitAbbreviation = (unit) => {
    switch (unit) {
        case 'feet':
            return 'ft';
        case 'meters':
            return 'm';
        case 'kilometers':
            return 'km';
        case 'miles':
            return 'mi';
        case 'yards':
            return 'yd';
    }
    return 'ft';
};
exports.getUnitAbbreviation = getUnitAbbreviation;
const round = (value, roundingPrecision) => {
    return Number(exports.distanceDisplayString(value, roundingPrecision));
};
exports.round = round;
const distanceDisplayString = (distance, roundingPrecision) => {
    let toFixedPlace = 0;
    if (roundingPrecision === 'tenths') {
        toFixedPlace = 1;
    }
    else if (roundingPrecision === 'hundredths') {
        toFixedPlace = 2;
    }
    else if (roundingPrecision === 'thousandths') {
        toFixedPlace = 3;
    }
    return distance.toFixed(toFixedPlace);
};
exports.distanceDisplayString = distanceDisplayString;
const compileKeysOfObjectArray = (objectsToFindKeys) => {
    let uniqueKeysArray = [];
    objectsToFindKeys.map(x => {
        const localKeys = Object.keys(x);
        uniqueKeysArray = union_1.default(uniqueKeysArray, localKeys);
    });
    return uniqueKeysArray;
};
exports.compileKeysOfObjectArray = compileKeysOfObjectArray;
const trimTrailingSlash = (str) => (str && str.length && str.endsWith('/') ? str.slice(0, -1) : str);
exports.trimTrailingSlash = trimTrailingSlash;
exports.WWW_URL_PREFIX = 'www.';
exports.HTTPS_URL_PREFIX = 'https://';
exports.URL_REGEX = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
exports.MOBILE_BREAKPOINT = 768;
//# sourceMappingURL=common.js.map